import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { setAccessToken, formatApiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = loading, false = anon, object = logged in
    const [error, setError] = useState(null);

    const fetchMe = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch (e) {
            setUser(false);
        }
    }, []);

    useEffect(() => {
        fetchMe();
    }, [fetchMe]);

    const login = async (email, password) => {
        setError(null);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            if (data.access_token) setAccessToken(data.access_token);
            setUser(data);
            return data;
        } catch (e) {
            const msg = formatApiError(e.response?.data?.detail) || e.message;
            setError(msg);
            throw new Error(msg);
        }
    };

    const register = async (payload) => {
        setError(null);
        try {
            const { data } = await api.post("/auth/register", payload);
            if (data.access_token) setAccessToken(data.access_token);
            setUser(data);
            return data;
        } catch (e) {
            const msg = formatApiError(e.response?.data?.detail) || e.message;
            setError(msg);
            throw new Error(msg);
        }
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch (_e) {
            // ignore
        }
        setAccessToken(null);
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, error, login, register, logout, refresh: fetchMe }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
